import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import { H1 } from 'components/common/Text/Text'
import Columns from 'components/common/Columns/Columns'
import Media from 'components/common/Media'
import { Map, MapMarker } from 'components/common/GoogleMaps'
import {
  StoreRating,
  MakeAppointmentButton,
  MakeThisMyStoreButton,
  ShopTiresButton,
  StoreDetails
} from './components'

const StoreInformationWrapper = ({
  storeNum,
  locationName,
  isCurrentStore,
  locationAppointmentEnabled,
  locationCoords,
  myLocationHandlers: {
    isLoading
  } = {},
  handleSetMyLocation,
  handleShopTires,
  ratingData,
  title,
  ...props
}) =>
  <React.Fragment>
    <HeaderSection>
      <ShopNameAndRatingWrapper>
        <ShopName data-at-heading="store-details" headline narrow block noMargin>{ locationName }</ShopName>
        <StoreRating storeNum={ storeNum } reviewName={ locationName } ratingData={ ratingData } />
      </ShopNameAndRatingWrapper>
      <HeaderButtonsWrapper data-printless>
        <MakeThisMyStoreButton
          data-at-store-makethismystore
          full="mobile"
          stacked="mobile"
          secondary
          narrow
          disabled={ isLoading || isCurrentStore }
          handleSetMyLocationClick={ handleSetMyLocation }>Make this my store</MakeThisMyStoreButton>
        {
          locationAppointmentEnabled &&
          <MakeAppointmentButtonCustom
            data-at-store-makeanappointment
            narrow
            full="mobile"
            stacked="mobile">{ title }</MakeAppointmentButtonCustom>
        }
        <ShopTiresButton
          data-at-store-shoptires
          full="mobile"
          stacked="mobile"
          narrow
          handleShopTiresClick={ handleShopTires }>Shop tires</ShopTiresButton>
      </HeaderButtonsWrapper>
    </HeaderSection>
    <ShopDetailsSection adaptive width="50%">
      <MapWrapper data-at-map="store-details">
        <Map center={ locationCoords } defaultZoom={ 8 } >
          <MapMarker position={ locationCoords } />
        </Map>
      </MapWrapper>
      <StoreDetailsWrapper>
        <StoreDetails { ...props } locationCoords={ locationCoords } storeNum={ storeNum } ratingData={ ratingData } />
      </StoreDetailsWrapper>
    </ShopDetailsSection>
  </React.Fragment>

StoreInformationWrapper.propTypes = {
  handleSetMyLocation: PropTypes.func,
  handleShopTires: PropTypes.func,
  isCurrentStore: PropTypes.bool,
  locationAppointmentEnabled: PropTypes.bool,
  locationCoords: PropTypes.shape(),
  locationName: PropTypes.string,
  myLocationHandlers: PropTypes.shape(),
  ratingData: PropTypes.shape(),
  storeNum: PropTypes.string,
  title: PropTypes.string
}

export default StoreInformationWrapper

const Section = styled.div`
  ${Mixin.responsive('padding', '17px 50px', '17px 25px')}
  ${Mixin.clearFix()}
`

const HeaderSection = styled(Section)`
  ${Mixin.responsive('padding', '17px 0 22px', '0 16px 10px')}
`

const ShopDetailsSection = styled(Columns)`
  padding: 0;
`

const StoreDetailsWrapper = styled.div`
  ${Mixin.responsive('padding', '0 0 25px', '0 16px')}
  ${Media.desktop`
    min-height: 400px;
    ${Mixin.clearFix()}
  `}

  ${Media.mobile`
    padding-bottom: 30px;
  `}
`

const MapWrapper = styled.div`
  ${Media.desktop`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  `}
  ${Media.mobile`
    position: relative;
    height: 180px;
  `}
`

const ShopNameAndRatingWrapper = styled.div`
  ${Media.desktop`
    display: inline-block;
    float:left;
  `}
`

const ShopName = styled(H1)`
  ${Media.mobile`
    font-size: 20px;
  `}
`

const HeaderButtonsWrapper = styled.div`
  ${Media.mobile`
    padding: 30px 0;
  `}

  ${Media.desktop`
    float: right;
  `}
`

const MakeAppointmentButtonCustom = styled(MakeAppointmentButton)`
  ${Media.mobile`
    margin-top: 15px;
  `}
`
